import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';

import DyPage from './DyPage';
import { getCookie } from '../Utils/FormUtils';

var HomePage = function HomePage(_ref) {
  var addVariantToCart = _ref.addVariantToCart,
      checkout = _ref.checkout;

  return React.createElement(
    Fragment,
    null,
    React.createElement(DyPage, {
      addVariantToCart: addVariantToCart,
      checkout: checkout,
      dySlug: 'homepage-top',
      sliderId: 'home-dy-slider-top'
    }),
    React.createElement(DyPage, {
      addVariantToCart: addVariantToCart,
      checkout: checkout,
      dySlug: 'homepage',
      sliderId: 'home-dy-slider'
    })
  );
};

HomePage.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired
};

export default HomePage;